// Entry point for the build script in your package.json

// Libraries
import './lib/rails';
import './lib/jquery';
import './lib/bootstrap';
import './lib/turbo';

// App modules
import './cable';

// Users
import './users/profile';

// STIMULUS
import './controllers';

if (!Rails.started) {
  Rails.start();
}
